import React, { useCallback, useState } from 'react';
import { Logo } from '../ui/Logo';
import { LegalModal } from '../legal/LegalModal';
import { legalDocs, type LegalDocId } from '../../data/legal';
export function Footer() {
  const [openId, setOpenId] = useState<LegalDocId | null>(null);
  const close = useCallback(() => setOpenId(null), []);
  return <footer className="w-full border-t border-line bg-ink" data-id="element-46" data-mp="5mkle6up79rp">
      <div className="mx-auto max-w-7xl px-5 py-10 sm:px-8" data-id="element-47" data-mp="oj33o53jeha">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between" data-id="element-48" data-mp="q2kji2hnvkn">
          <div className="flex flex-col gap-2" data-id="element-49" data-mp="3s0kgaiedjsi1">
            <Logo data-id="element-50" data-mp="3n2spjrpgucff" />
            <p className="text-sm text-muted" data-id="element-51" data-mp="3n4djbf3yhrc8">Fitness real para latinos en Estados Unidos.</p>
          </div>
          <nav aria-label="Legal" data-id="element-52" data-mp="3j3jvelqikcjc">
            <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-53" data-mp="3j05vdk5boff2">
              {legalDocs.map(d => <li key={d.id} data-id="element-54" data-mp="393t0wk1ydxj9">
                  <button type="button" onClick={() => setOpenId(d.id)} className="text-sm text-muted underline-offset-4 transition-colors duration-150 ease-out hover:text-white hover:underline focus-visible:text-white focus-visible:underline focus-visible:outline-none" data-id="element-55" data-mp="393ja4u933mci">
                    {d.label}
                  </button>
                </li>)}
            </ul>
          </nav>
        </div>
        <div className="mt-8 flex flex-col gap-2 border-t border-line pt-6 text-xs text-muted md:flex-row md:justify-between" data-id="element-56" data-mp="340khqtuhcb6c">
          <p data-id="element-57" data-mp="381e59m40fnyp">© 2026 Evaluación Fitness Jseefect. Todos los derechos reservados.</p>
          <p data-id="element-58" data-mp="2u3pho6ik62py">Los resultados pueden variar. Este sitio no ofrece consejo médico.</p>
        </div>
      </div>
      <LegalModal openId={openId} onClose={close} onSwitch={setOpenId} data-id="element-59" data-mp="2z0y44jaqosx0" />
    </footer>;
}